export const sliderData = [
  {
    background: 'mobiles',
    content: 'Why UX and UI design matters to us',
    description:
      'In a world flooded with poorly designed products that do the bare minimum, a human-centred product stands out.',
    color: 'violet',
    link: '/work/why-design-matters/',
  },
  {
    background: 'about',
    content: 'When two become one',
    description:
      'Boldare is the result of a natural merge of two sister companies XSolve and Chilid',
    color: 'yellow',
    link: '/blog/the-story-of-boldare/',
  },
  {
    background: 'boldareWireframe',
    content: 'How to test a business idea',
    description:
      'Find out how we created Boldare leveraging lean startup thinking',
    color: 'red',
    link: '/work/case-study-boldare/',
  },
];
